
const { log } = require('app-lib-log');
const commander = require('app-lib-commander');
const nodeUtils = require('app-lib-node');
const STATIC = require('app-lib-trans-storage');
const { exec } = require('app-lib-exec');

const utils = require('./common/utils');
const noBuild = require("app-lib-nobuild");
const OPTIONS = require('./common/options');
const { ARGUMENTS } = require('./common/arguments');
const Error = require('./common/app-lib-error');
const CONSTANT = require('./constant/constant')
module.exports = {
    nodeUtils,
    utils,
    exec,
    commander,
    log,
    noBuild,
    OPTIONS, // 常用的option
    ARGUMENTS, // 常用debugger
    Error,
    STATIC,//静态文件存储
    CONSTANT,//常量
}